function countdown() {

    if ( !! $j('#akel-countdown').length )  {

        var defaultOptions = {
            'timezone': "America/New_York"
        };
        $j("#akel-countdown").each(function () {
            var el = $j(this);
            var options = $j.extend({}, defaultOptions, el.data());
            var time = moment.tz(options.time, options.timezone);
            //var format = " %-D day%!D, %H:%M:%S";
            var format = "%D <b>:</b> %H <b>:</b> %M <b>:</b> %S";
            el.countdown(time.toDate())
                .on('update.countdown', function (event) {
                    $j(this).html(event.strftime(format));
                })
                .on('finish.countdown', function (event) {
                    $j(this).html('00 <b>:</b> 00 <b>:</b> 00 <b>:</b> 00');
                    $j(this).after('<a href="">Start Live Stream</a>');
                });
        });

    }

    if(!!$j('#event-countdown').length){
        var debugMode=0;
        var defaultOptions={'timezone':"America/New_York"};
        $j("#event-countdown").each(function(){
            var el=$j(this);
            var options=$j.extend({},defaultOptions,el.data());
            var time=moment.tz(options.time,options.timezone)
            var renderTemplate=function(days,hours,minutes,seconds){
                return `<ul>
                    <li class="days"><span class="ticker">${days}</span><span class="label">Days</span></li>
                    <li class="hours"><span class="ticker">${hours}</span><span class="label">Hours</span></li>
                    <li class="minutes"><span class="ticker">${minutes}</span><span class="label">Minutes</span></li>
                    <li class="seconds"><span class="ticker">${seconds}</span><span class="label">Seconds</span></li>
                </ul>`
            }
            if(debugMode){
                // Just write once and stop
                var now=moment()
                var diff=moment.duration(time.diff(now))
                el.html(renderTemplate(
                    diff.days().toString().padStart(2,'0'),
                    diff.hours().toString().padStart(2,'0'),
                    diff.minutes().toString().padStart(2,'0'),
                    diff.seconds().toString().padStart(2,'0')
                ));
            }else{
                // Normal live countdown
                el.countdown(time.toDate())
                    .on('update.countdown',function(event){
                        $j(this).html(renderTemplate(
                            event.strftime('%D'),
                            event.strftime('%H'),
                            event.strftime('%M'),
                            event.strftime('%S')
                        ))
                    })
                    .on('finish.countdown',function(){
                        $j(this).html(renderTemplate('00','00','00','00'))
                    });
            }
        })
    }



};
